var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonSquareTickDdgreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .square-tick-st0 {\n        fill: #2eb4a9;\n        stroke: #2eb4a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.12px;\n      }\n\n      .square-tick-st1 {\n        fill: #fff;\n        stroke: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "square-tick-st0",
    x: 5.21,
    y: 5.21,
    width: 39.58,
    height: 39.58,
    rx: 6.25,
    ry: 6.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "square-tick-st1",
    d: "M21,37.46l-8.4-7.75c-.82-.76-.87-2.04-.11-2.87l1.74-1.89c.76-.82,2.04-.87,2.87-.11l4.47,4.13,10.65-16.06c.63-.93,1.89-1.17,2.82-.54l2.13,1.44c.93.63,1.17,1.89.54,2.82l-13.65,20.49c-.7,1.03-2.14,1.2-3.06.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSquareTickDdgreen);
export default __webpack_public_path__ + "static/media/button_square_tick_ddgreen.ce0952949da11cdc89d75591059df923.svg";
export { ForwardRef as ReactComponent };